var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrames({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V50L7.56902 43.7273L13.7394 48.6193L20.1062 43.7273L26.1853 49.425L32.4238 43.7273L38 50V0H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3571 29.5117H8.76416V31.0877H29.3571V29.5117Z",
    fill: "#F00000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3571 35.3535H8.76416V36.9295H29.3571V35.3535Z",
    fill: "#F00000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4331 11.3518C17.4331 15.0536 15.0054 16.9868 12.3522 16.9868C9.5574 16.9868 7.35498 14.9718 7.35498 11.6509C7.35498 8.49345 9.35876 6.09878 12.4928 6.09878C15.6547 6.09766 17.4331 8.32992 17.4331 11.3518ZM10.5448 11.5411C10.5448 13.3914 11.1929 14.7254 12.4359 14.7254C13.6498 14.7254 14.2422 13.5292 14.2422 11.5411C14.2422 9.74454 13.7346 8.3568 12.4068 8.3568C11.1372 8.3568 10.5448 9.77254 10.5448 11.5411ZM12.5764 24.3903L23.1076 6.09766H25.4227L14.8636 24.3903H12.5764ZM30.6453 18.7016C30.6453 22.4034 28.2175 24.3366 25.5644 24.3366C22.7975 24.3366 20.5962 22.3216 20.5672 19.0006C20.5672 15.8432 22.5709 13.4486 25.705 13.4486C28.8669 13.4474 30.6453 15.6797 30.6453 18.7016ZM23.7848 18.8909C23.7569 20.7412 24.4051 22.0752 25.648 22.0752C26.8619 22.0752 27.4544 20.879 27.4544 18.8909C27.4544 17.0943 26.9746 15.7066 25.648 15.7066C24.3494 15.7066 23.7848 17.1223 23.7848 18.8909Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrames);
export default __webpack_public_path__ + "static/media/Frames.27cbc0e0a57a7489af3c3b3b3b83913b.svg";
export { ForwardRef as ReactComponent };